import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const { processGoogleSession } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', '?'));
    const sessionId = params.get('session_id');

    // Clear hash to prevent re-processing
    if (window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname);
    }

    if (sessionId) {
      processGoogleSession(sessionId)
        .then((data) => {
          navigate(data.user.role === 'admin' ? '/admin' : '/member', { replace: true });
        })
        .catch((err) => {
          setError(err.response?.data?.detail || 'Google login gagal. Silakan coba lagi.');
          setTimeout(() => navigate('/login', { replace: true }), 3000);
        });
    } else {
      setError('Session tidak ditemukan');
      setTimeout(() => navigate('/login', { replace: true }), 2000);
    }
  }, [processGoogleSession, navigate]);

  return (
    <div style={{ minHeight: '100vh', background: '#0A0A0A', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {error ? (
        <div style={{ textAlign: 'center' }}>
          <p style={{ color: '#f87171', fontSize: '1rem', marginBottom: '0.5rem' }}>{error}</p>
          <p style={{ color: '#71717A', fontSize: '0.85rem' }}>Mengalihkan ke halaman login...</p>
        </div>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <Loader2 size={36} color="#0D7377" style={{ animation: 'spin 1s linear infinite' }} />
          <p style={{ color: '#EDEDED', marginTop: '1rem' }}>Memproses login Google...</p>
          <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
        </div>
      )}
    </div>
  );
}
